import { useEffect } from 'react';
import { applyRumSettings, type RumTenantSettingRow } from './applyRumSettings';

/**
 * Applies tenant RUM ability from settings already loaded by the host app.
 * - doc-web: `useGetGlobalSettingsQuery` (doc-data)
 * - PAL: `useGetGlobalSettingsQuery` / `useGetGlobalSettingsGuestQuery` (pal advisorApi)
 */
export function RumSettingsSync({
  settings,
}: Readonly<{ settings?: RumTenantSettingRow[] | undefined }>): null {
  useEffect(() => {
    applyRumSettings(settings);
  }, [settings]);

  return null;
}
